/**
 * Curated seed apps for the cold-start Explore grid.
 *
 * Each entry has:
 *   trackId  — Apple numeric app id (string to avoid precision issues)
 *   name     — display name shown on the card
 *   blurb    — one-line hook about its cross-country angle
 *   theme    — grouping key: 'global' | 'regional' | 'insight'
 *
 * Rules: no two entries may share a trackId.
 * No network calls are made on page load; cards trigger the existing runById flow
 * only when clicked.
 */

/** @typedef {{ trackId: string, name: string, blurb: string, theme: 'global'|'regional'|'insight' }} SeedEntry */

/** @type {SeedEntry[]} */
export const DISCOVERY_SEED = [
  // Global giants — chart in virtually every storefront
  { trackId: '284882215', name: 'Facebook',      blurb: 'How does pricing and availability shift across supported countries?', theme: 'global' },
  { trackId: '389801252', name: 'Instagram',     blurb: 'Free everywhere — but rating and traction vary wildly.', theme: 'global' },
  { trackId: '310633997', name: 'WhatsApp',      blurb: 'Near-universal reach; spot gaps in restricted markets.', theme: 'global' },
  { trackId: '544007664', name: 'YouTube',       blurb: 'Dominant globally — where is it absent or rated lower?', theme: 'global' },
  { trackId: '333903271', name: 'Twitter / X',   blurb: 'See which markets are most engaged vs least traction.', theme: 'global' },

  // Big in one region — strong locally, less visible elsewhere
  { trackId: '925972929', name: 'LINE',          blurb: '#1 messaging in Japan, Korea, and Thailand — barely visible elsewhere.', theme: 'regional' },
  { trackId: '1478890813', name: 'Zenly',        blurb: 'Big in France, Japan; low US traction. Classic regional gem.', theme: 'regional' },
  { trackId: '986718583', name: 'Mercari',       blurb: 'Dominant C2C marketplace in Japan — early-mover gap in the West?', theme: 'regional' },
  { trackId: '1014600083', name: 'SNOW Camera',  blurb: 'Selfie-filter hit in East Asia; compare popularity across supported storefronts.', theme: 'regional' },
  { trackId: '462848931', name: 'Bilibili',      blurb: 'Chinese video platform: available abroad with surprisingly varied ratings.', theme: 'regional' },

  // Insight picks — interesting cross-country data angles
  { trackId: '1232780281', name: 'Duolingo',     blurb: 'Freemium across the globe — price and popularity diverge by market.', theme: 'insight' },
  { trackId: '422689480', name: 'Gmail',         blurb: 'Google app availability gap: some markets surprisingly absent.', theme: 'insight' },
  { trackId: '835599320', name: 'Notion',        blurb: 'Productivity darling — see where it tops charts vs where it\'s unknown.', theme: 'insight' },
  { trackId: '1496833156', name: 'BeReal',       blurb: 'Viral in Europe and the US; track how it spread market by market.', theme: 'insight' },
];

/** Theme display order */
export const THEME_ORDER = ['global', 'regional', 'insight'];
